<template>
  <div v-loading.fullscreen.lock="loading" class="brand-detail">
    <div class="tabs clear">
      <a class="fl" :href="`/mall?city=${$route.query.city}`" target="_self">{{
        TLang("商城首页", "my")
      }}</a>

      <img
        class="fl"
        :src="require('@assets/images/birthday/tab_icon.png')"
        alt=""
      />

      <router-link class="fl" to="/birthday">
        {{ TLang("生日汇", "my") }}
      </router-link>

      <img
        class="fl"
        :src="require('@assets/images/birthday/tab_icon.png')"
        alt=""
      />

      <span class="fl">{{ TLang("品牌详情", "my") }}</span>
    </div>
    <div v-if="resCode===90001">
      <empty content="暂无数据" />

    </div>
    <div  v-else>
      <brand-info
        :logo="brandDetail.logo"
        :brandName="brandDetail.name"
        :brandIntroduction="brandDetail.introduction"
        :minPrice="minPrice"
      />

      <div class="detail-info">
        <ul class="tab-list clear">
          <li
            v-if="
              (brandDetail.goodsDtos && brandDetail.goodsDtos.length) ||
                (brandDetail.openPay && brandDetail.openPay == 1)
            "
            class="fl"
            :class="{ active: tabIndex === 0 }"
            @click="handleScrollIntoView($refs.goodsList, 0)"
          >
            {{ TLang("商品", "my") }}
          </li>
          <li
            v-if="brandDetail.salesrooms && brandDetail.salesrooms.length"
            class="fl"
            :class="{ active: tabIndex === 1 }"
            @click="handleScrollIntoView($refs.storeList, 1)"
          >
            {{ TLang("适用门店", "my") }}
          </li>
          <li
            v-if="brandDetail.story"
            class="fl"
            :class="{ active: tabIndex === 2 }"
            @click="handleScrollIntoView($refs.brandStory, 2)"
          >
            {{ TLang("品牌故事", "my") }}
          </li>
        </ul>

        <div class="detail-info-wrap">
          <div class="margin80"></div>
          <div class="margin80 padding80" ref="goodsList">
            <div
              class="flex-box changeTipWrap"
              v-if="brandDetail.openPay && brandDetail.openPay == 1"
            >
              <div class="changeTitle">
                <!-- 随心兑折扣价 -->
                <!-- <img src="../../assets/images/birthday/suixindui.png" class="changeIcon"> -->
                <span class="changeIcon">{{ TLang("兑", "my") }}</span>
                <span class="discount-info" v-if="brandDetail.discount"
                  >{{ brandDetail.discount }}{{ TLang("折", "my") }}</span
                >
                <!-- <span class="changeInfo">{{TLang('消费','my')}}{{brandDetail.threshold && brandDetail.threshold > 0 ? TLang('满','list')+ brandDetail.threshold +TLang('元','my'): TLang('任意金额','my')}}{{TLang('可用，需到店使用','my')}}</span> -->
                <span class="changeInfo">{{
                  brandDetail.threshold && brandDetail.threshold > 0
                    ? ReplaceText(
                        "XXXX",
                        brandDetail.threshold,
                        TLang("消费满可用", "my")
                      )
                    : TLang("消费任意可用", "my")
                }}</span>
              </div>
              <button class="changeBtn" v-if="codeImg" @click="showXCX">
                {{ TLang("随心兑", "my") }}
              </button>
            </div>
            <goods-list
              v-if="brandDetail.goodsDtos && brandDetail.goodsDtos.length"
              :goodsList="brandDetail.goodsDtos || []"
              :style="{ marginTop: !brandDetail.openPay ? '34px' : '' }"
            />
          </div>

          <div ref="storeList" class="padding80 margin80">
            <store-list
              v-if="brandDetail.salesrooms && brandDetail.salesrooms.length"
              :regions="brandDetail.regions || []"
              :salesrooms="brandDetail.salesrooms || []"
            />
          </div>

          <div ref="brandStory" class="brand-story padding80">
            <h3 v-if="brandDetail.story">
              {{ TLang("品牌故事", "my") }}
            </h3>
            <p v-html="brandDetail.story"></p>
          </div>
        </div>
      </div>
      <el-dialog
        title=""
        top="35vh"
        :visible.sync="codeVisible"
        width="420px"
        :show-close="false"
        custom-class="codeDialog"
        :before-close="handleClose"
      >
        <div class="codeInfo">
          <img
            class="close"
            :src="require('@assets/images/birthday/close_icon.png')"
            alt=""
            @click="handleClose"
          />
          <div class="dialogImg">
            <img :src="codeImg" alt="" />
          </div>
          <p class="wechat">{{ TLang("微信扫一扫", "my") }}</p>
          <p class="tip">{{ TLang("使用微信扫码立即体验随心兑", "my") }}</p>
        </div>
      </el-dialog>
    </div>

    
  </div>
</template>

<script>
import BrandInfo from "./brandInfo";
import GoodsList from "./goodsList";
import StoreList from "./storeList";
import Empty from "@components/empty";
import { getBrandDetailData, getBrandAppletsCode } from "@fetch/birthday";
export default {
  name: "BrandDetail",

  components: {
    BrandInfo,
    GoodsList,
    StoreList,
    Empty,
  },

  data() {
    return {
      tabIndex: 0,
      brandDetail: {},
      loading: true,
      currentTab: -1,
      codeImg: "",
      codeVisible: false,
      resCode: 0,
    };
  },

  computed: {
    minPrice() {
      if (!this.brandDetail.goodsDtos || !this.brandDetail.goodsDtos.length)
        return -1;
      return this.brandDetail.goodsDtos[0].sellingPrice;
    },
  },

  beforeRouteEnter(to, from, next) {
    // 设置body背景色
    document.body.classList.add("is-birthday");
    next();
  },

  beforeRouteLeave(to, from, next) {
    // 移除body背景色
    document.body.classList.remove("is-birthday");
    next();
  },

  created() {
    this.getBrandDetailData(this.$route.params.brandId);
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    /**
     * tab切换
     * @param { Object } ref ref对象
     */
    handleScrollIntoView(ref, index) {
      this.currentTab = index;
      ref.scrollIntoView({ behavior: "smooth" });
    },

    // 滚动事件
    handleScroll() {
      const { storeList, brandStory } = this.$refs;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.tabIndex = storeList && scrollTop > storeList.offsetTop - 1 ? 1 : 0;
      brandStory && scrollTop > brandStory.offsetTop - 1 && (this.tabIndex = 2);
    },

    /**
     * 获取品牌详情数据
     * @param { String }  brandId  品牌id
     * @param { String } sort  asc 低到高  desc 高到低
     */
    async getBrandDetailData(brandId, sort = "asc") {
      const res = await getBrandDetailData({
        brandId,
        sort,
      });
      this.resCode = res.code;
      this.loading = false;
      this.brandDetail = res || {};
      // if (this.brandDetail.openPay && this.brandDetail.openPay == 1) {
      //   this.getBrandAppletsCode(this.$route.params.brandId)
      // }
      if (
        this.brandDetail.openPay &&
        this.brandDetail.openPay == 1 &&
        this.brandDetail.openPayBrandId
      ) {
        this.getBrandAppletsCode(this.brandDetail.openPayBrandId);
      }
    },

    // 展示随心兑小程序码
    showXCX() {
      this.codeVisible = true;
    },
    handleClose() {
      this.codeVisible = false;
    },

    /**
     * 获取小程序码
     * @param { Number } brandId 品牌ID
     */
    async getBrandAppletsCode(brandId) {
      const resp = await getBrandAppletsCode({
        brandId,
      });
      this.codeImg = resp || "";
    },
  },
};
</script>

<style lang="less" scoped>
.brand-detail {
  // padding-bottom: 1000px;
  .tabs {
    font-size: 16px;
    margin-bottom: 20px;
    a {
      width: 100px;
      border: 1px solid #ededed;
      color: #1a4a9e;
      text-align: center;
      line-height: 28px;
      border-radius: 5px;
      &:hover {
        background: #619ee0;
        color: #fff;
      }
    }
    img {
      width: 7px;
      height: 14px;
      margin: 8px 15px 0;
    }
    span {
      width: 100px;
      line-height: 30px;
      color: #fff;
      text-align: center;
      border-radius: 5px;
      background: #619ee0;
    }
  }
  .detail-info {
    background: #fff;
    border: 1px solid #ececec;
  }
  .tab-list {
    line-height: 60px;
    font-size: 18px;
    color: #1a4a9e;
    border-bottom: 1px solid #ececec;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 99;
    height: 60px;
    box-sizing: border-box;
    li {
      width: 160px;
      text-align: center;
      border-right: 1px solid #ececec;
      cursor: pointer;
      height: 60px;
      box-sizing: border-box;
      &.active {
        border-top: 3px solid #1a4a9e;
        background: #fff;
      }
      &:hover {
        color: #ff0000;
      }
    }
  }
  .detail-info-wrap {
    padding: 0 36px 40px;
    .changeTipWrap {
      padding: 24px 20px;
      .changeTitle {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .discount-info {
          // padding: 2px;
          // background-color: rgba(250, 140, 22, .2);
          font-size: 14px;
          // line-height: 12px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #fa8c16;
          margin-right: 9px;
        }
      }
      .changeIcon {
        color: #fff;
        background: #4a9fe6;
        width: 22px;
        line-height: 22px;
        border-radius: 2px;
        display: inline-block;
        text-align: center;
        margin-right: 10px;
      }
      .changeInfo {
        line-height: 22px;
        font-size: 14px;
        font-family: MicrosoftYaHeiUI;
        // color: #1A4A9E;
        color: #000000;
      }
      .changeBtn {
        width: 100px;
        height: 38px;
        line-height: 38px;
        background: #ee0020;
        border-radius: 5px;
        text-align: center;
        color: #fff;
        font-size: 14px;
      }
    }
    .flex-box {
      display: flex;
      justify-content: space-between;
    }
  }
  .brand-story {
    font-size: 14px;
    color: #333;
    h3 {
      font-size: 20px;
      color: #2351a2;
      margin-bottom: 30px;
      line-height: 1;
    }
    img {
      max-width: 100%;
    }
  }

  .codeDialog {
    .codeInfo {
      text-align: center;
      margin-top: -12px;
      position: relative;
      .close {
        position: absolute;
        width: 30px;
        height: 30px;
        top: -36px;
        right: -8px;
        cursor: pointer;
      }
      .dialogImg {
        width: 148px;
        height: 148px;
        border-radius: 2px;
        border: 1px solid #e0e6ed;
        margin: 0 auto 16px;
        img {
          display: block;
          width: 124px;
          height: 124px;
          margin: 12px auto;
        }
      }
      .wechat {
        font-size: 18px;
        color: #3d96e2;
        line-height: 20px;
      }
      .tip {
        font-size: 14px;
        color: #000;
        line-height: 20px;
      }
    }
  }

  .padding80 {
    padding-top: 80px;
  }
  .padding24 {
    padding-top: 24px;
  }
  .margin80 {
    margin-bottom: -80px;
  }
}
</style>
